// extracted by mini-css-extract-plugin
export default {"ontop":"Popper_ontop__C2Y6x","find":"Popper_find__agCrH","logo":"Popper_logo__wqyni","wrapper":"Popper_wrapper__WhyWo"};